// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xO","emblaSlide":"xP","textActive":"xQ"};